import { useQuery } from '@tanstack/react-query'
import usePagination from 'hooks/usePagination'
import { getCustomTearsheetTemplateRequests } from 'services/tearsheets'

const useTemplateRequests = () => {
  const { pagination, handlePageChange, handleRowsChange, pageSizeOptions } = usePagination()

  const params = {
    pageOffset: pagination.pageOffset,
    pageSize: pagination.pageSize,
  }

  const {
    data: { data: requests, meta },
    isFetching,
  } = useQuery(
    ['customTearsheetTemplateRequests', params],
    () => getCustomTearsheetTemplateRequests(params),
    {
      initialData: { data: [], meta: { itemCount: 0 } },
      refetchOnWindowFocus: false,
      useErrorBoundary: true,
      keepPreviousData: true,
    },
  )

  return {
    requests,
    itemCount: meta.itemCount,
    isFetching,
    page: pagination.page,
    pageSize: pagination.pageSize,
    pageSizeOptions,
    handlePageChange,
    handlePageSizeChange: handleRowsChange,
  }
}

export default useTemplateRequests
